<template >
  <div>
    <div class="marBot10 clear" style="width: 786px">
      <div class="l">
        <span class="fontB font12">Shipment units：</span>
        <el-radio
          class="marL10"
          @change="changeUnit"
          v-model="volumeUnit"
          :label="0"
        >
          <span class="font12">KG/CBM</span>
        </el-radio>
        <el-radio
          v-model="volumeUnit"
          @change="changeUnit"
          :label="1"
          style="margin-left: 161px"
        >
          <span class="font12">LB/CFT</span>
        </el-radio>
      </div>
      <!-- <div class="total r">
        <p>
          <span>Shipment total: </span>
          <em class="marR20">{{ sumUnit }} Unit</em>
          <em class="marR10">{{ InterceptUnit(sumKG, 3) }} KG</em>
          <em class="min-em">{{ InterceptUnit(sumCBM, 4) }} CBM</em>
        </p>
        <p>
          <em class="marR10">{{ InterceptUnit(sumLB, 3) }} LB</em>
          <em class="min-em">{{ InterceptUnit(sumCFT, 4) }} CFT</em>
        </p>
      </div> -->
    </div>
    <ul style="margin-left: 117px">
      <li style="min-height: 50px">
        <div class="clear l">
          <div class="clear l marR20" :class="{ borColRed: !totalInfo.unit }">
            <input
              style="width: 120px"
              class="inputAll w1"
              type="text"
              maxlength="4"
              placeholder="Total unit"
              v-model="totalInfo.unit"
              @keyup="intNum('unit')"
              @blur="noZero('unit')"
              v-on:input="sendMsg"
            />
            <p class="rigW" style="width: 113px; overflow: hidden">
              <el-select v-model="totalInfo.unitValue" class="unit_select">
                <el-option
                  v-for="item in unitOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </p>
            <div v-show="!totalInfo.unit" class="colRed">required</div>
          </div>
        </div>
        <div class="clear l">
          <div class="clear l marR20" :class="{ borColRed: !totalInfo.weight }">
            <input
              style="width: 195px"
              class="inputAll w1"
              type="text"
              placeholder="Total weight"
              @keyup="totalInfo.weight = clearNoNum(totalInfo.weight)"
              @blur="noZero('weight')"
              v-model="totalInfo.weight"
              v-on:input="sendMsg"
            />
            <p class="rigW">{{ volumeUnit === 0 ? "KG" : "LB" }}</p>
          </div>
          <div v-show="!totalInfo.weight" class="colRed">required</div>
        </div>
        <div class="clear l">
          <div class="clear l marR10" :class="{ borColRed: !totalInfo.volume }">
            <input
              style="width: 195px"
              class="inputAll w1"
              type="text"
              @keyup="totalInfo.volume = clearNoNum(totalInfo.volume)"
              placeholder="Total Volume "
              v-model="totalInfo.volume"
              @blur="noZero('volume')"
              v-on:input="sendMsg"
            />
            <p class="rigW">{{ volumeUnit === 0 ? "CBM" : "CFT" }}</p>
          </div>
          <div v-show="!totalInfo.volume" class="colRed">required</div>
        </div>
        <label class="hint tipsText">
          <i class="fa fa-tips4 colBlue fontSet" style="margin-top: 7px"></i>
          <div class="floTipBox" style="left: -23px; top: 32px">
            <i></i>
            <p v-show="volumeUnit == 0">
              Volume CBM= (length CM* width CM* height CM) /1000000
            </p>
            <p v-show="volumeUnit == 1">
              Volume CFT= (length IN/12) * (width IN/12) * (height IN/12)
            </p>
          </div>
        </label>
      </li>
    </ul>
  </div>
</template>
<script>
import { byTotal } from "@/utils/transfromUnit.js";
import EventBus from "@/ask/eventBus";

export default {
  mixins: [byTotal], //混入该方法 功能是：计算单位转换

  //props: ["value"],
  props: {
    weightDensity: Number,
    volumeDensity: Number,
    value: { type: Object },
  },
  model: {
    prop: "value",
    event: "sendByTotal",
  },

  watch: {
    // 将值传给v-model
    totalInfo: {
      deep: true,
      handler: function (newV, oldV) {
        this.changeUnit();
      },
    },
    weightDensity: {
      deep: true,
      handler: function (newV, oldV) {
        this.totalInfo.weight = newV;
        //this.weightDensity=newV
      },
    },
    volumeDensity: {
      handler: function (newV, oldV) {
        this.totalInfo.volume = newV;
        //this.volumeDensity=newV
      },
      deep: true,
    },
  },
  data() {
    return {
      volumeUnit: 0,
      weightD: this.weightDensity,
      volumeD: this.volumeDensity,
      unitOptions: [
        { value: "CTNS", label: "Carton" },
        { value: "PLTS", label: "Pallet" },
        { value: "WOODEN CASE", label: "Wooden Case" },
        { value: "OTHER", label: "Other" },
      ],

      totalInfo: {
        unitValue: "CTNS",
        unit: "",
        weight: this.weightDensity ? this.weightDensity : "",
        volume: this.volumeDensity ? this.volumeDensity : "",
      },
    };
  },
  mounted() {
    // EventBus.$on("query", (msg) => {
    //this.totalInfo.weight = this.weightD; //msg.W;
    //this.totalInfo.volume = this.volumeD; //msg.C;
    // })
  },
  created() {
    this.totalInfo.unit = this.$route.query.unitQty;
    this.totalInfo.weight = this.$route.query.weight;
    this.totalInfo.volume = this.$route.query.cbm;
    this.totalInfo.unitValue = this.$route.query.unitLabel;
  },

  methods: {
    sendMsg() {
      let newValue = {
        totalInfo: this.totalInfo,
        total: {
          sumUnit: this.sumUnit,
          sumKG: this.sumKG,
          sumCBM: this.sumCBM,
          sumLB: this.sumLB,
          sumCFT: this.sumCFT,
        },
        volumeUnit: this.volumeUnit,
      };
      EventBus.$emit("aMsg", newValue);
    },
    changeUnit() {
      let newValue = {
        totalInfo: this.totalInfo,
        total: {
          sumUnit: this.sumUnit,
          sumKG: this.sumKG,
          sumCBM: this.sumCBM,
          sumLB: this.sumLB,
          sumCFT: this.sumCFT,
        },
        volumeUnit: this.volumeUnit,
      };
      this.$emit("sendByTotal", newValue);
      EventBus.$emit("aMsg", newValue);
    },
    clearNoNum(ctrValue) {
      if (ctrValue) {
        //ctrValue = ctrValue.replace(/^\./g, ""); //验证第一个字符是数字而不是.
        ctrValue = ctrValue.replace(/[^\d\.]/g, "");
        if (ctrValue.indexOf(".") > -1) {
          let s = ctrValue.substring(ctrValue.indexOf(".") + 1);
          if (s.length > 3) {
            ctrValue = ctrValue.substring(0, ctrValue.indexOf(".") + 4);
          }
        }
        //获取小数点前面的值
        let arr = ctrValue.split(".");
        let le = arr[0].length;
        if (le > 7) {
          let int = arr[0].substring(0, 7);
          if (ctrValue.indexOf(".") > -1) {
            ctrValue = int + "." + arr[1];
          } else {
            ctrValue = int;
          }
        }
        return ctrValue;
      }
    },
    noZero(value) {
      let that = this;
      if (!this.totalInfo[value] == "") {
        this.$emit("sumbitQuery");
      }
      if (this.totalInfo[value] == 0) {
        this.totalInfo[value] = "";
      }
    },
    intNum(value) {
      if (this.totalInfo[value].length == 1) {
        this.totalInfo[value] = this.totalInfo[value].replace(/[^1-9]/g, "");
      } else {
        this.totalInfo[value] = this.totalInfo[value].replace(/\D/g, "");
      }
    },
  },
};
</script>
<style >
.unit_select .el-input__inner {
  border: none !important;
  background: #f7f7f7 !important;
  padding-left: 6px !important;
  font-size: 12px !important;
}
.unit_select .el-input__suffix {
  right: 0 !important;
}
</style>
<style scoped>
@import "../../../../assets/css/userCenterCss.css";
.total {
  text-align: right;
  font-size: 12px;
}
.fontB {
  font-weight: bold;
  color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/reception/air/query/calculateByTotal.vue